import NamedStorage from "./NamedStorage";

export default class CharacterStorage {
  private mStorage: NamedStorage;

  constructor() {
    this.mStorage = new NamedStorage("Character");
  }

  public GetStrength(): number {
    return this.mStorage.GetNumber("Strength");
  }
  public SetStrength(str: number) {
    return this.mStorage.Store("Strength", str.toString());
  }
  public GetVitality(): number {
    return this.mStorage.GetNumber("Vitality");
  }
  public SetVitality(vit: number) {
    return this.mStorage.Store("Vitality", vit.toString());
  }
  public GetDexterity(): number {
    return this.mStorage.GetNumber("Dexterity");
  }
  public SetDexterity(dex: number) {
    return this.mStorage.Store("Dexterity", dex.toString());
  }
  public GetIntelligence(): number {
    return this.mStorage.GetNumber("Intelligence");
  }
  public SetIntelligence(intel: number) {
    return this.mStorage.Store("Intelligence", intel.toString());
  }
  public GetAvailableAttributePoints(): number {
    return this.mStorage.GetNumber("AvailableAttributePoints");
  }
  public SetAvailableAttributePoints(points: number) {
    return this.mStorage.Store("AvailableAttributePoints", points.toString());
  }
  public GetAvailableSkillPoints(): number {
    return this.mStorage.GetNumber("AvailableSkillPoints");
  }
  public SetAvailableSkillPoints(points: number) {
    return this.mStorage.Store("AvailableSkillPoints", points.toString());
  }
}
